// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"231":"feed","263":"widget","791":"video"}[chunkId] + "." + {"231":"c54800aa1e5d6ef4c904","263":"1d687e5d4234c1df1bd2","791":"56500ef66df93dae1a9d"}[chunkId] + ".js";
};